export const CharacterClasses = [
    "Barbar",
    "Barde",
    "Druide",
    "Hexenmeister",
    "Kämpfer",
    "Kleriker",
    "Magier",
    "Mönch",
    "Paladin",
    "Schurke",
    "Waldläufer",
    "Zauberer",
] as const

export type CharacterClass = typeof CharacterClasses[number]

export const CasterCharacterClasses = [
    "Barde",
    "Druide",
    "Hexenmeister",
    "Kleriker",
    "Magier",
    "Paladin",
    "Waldläufer",
    "Zauberer",
] as const satisfies readonly CharacterClass[]

export function isCharacterClass(value: string): value is CharacterClass {
    return (CharacterClasses as readonly string[]).includes(value)
}

export function toCharacterClass(value: string): CharacterClass {
    if (!isCharacterClass(value)) throw new Error(`Unbekannte Charakterklasse: ${value}`)
    return value
}
